<!--
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-06-28 13:25:03
-->
<template>
    <Common>
      <template slot="cd">
          <CdhospitalDoctorVisit />
      </template>
    </Common>
</template>

<script>
import CdhospitalDoctorVisit from "@/components/physicianVisitInfo/cdPhysicianVisitInfo"
export default{
  components:{
    CdhospitalDoctorVisit
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>